import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            filter: '',
            openDeclineVacation: false,
            vacationToEdit: null,
            vacations: [],
            vacationsNotes: [],
            dates: [],
            driversOnVacation: new Map(),
            daysMap: new Map()
        }
    },
    computed: {
        filteredVacations() {
            return this.vacations.filter(item => {
                return checkNull(item.courier.firstName).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    checkNull(item.courier.lastName).toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                        checkNull(item.courier.username).toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
            }).sort((a,b) => this.compareByTime(a.date,b.date))
        }
    },
    methods: {
        getVacations: getVacations,
        checkNull: checkNull,
        getDrivers: getDrivers,
        getDisplayNameFromDay: getDisplayNameFromDay,
        getNumberForDate: getNumberForDate,
        generateDates: generateDates,
        getDisplayStatus: getDisplayStatus,
        openDeclineVacationModal: openDeclineVacationModal,
        getVacationsForDate: getVacationsForDate,
        initDaysMap: initDaysMap,
        approveVacations: approveVacations,
        declineVacations: declineVacations,
        getNumberOfCouriersByDate: getNumberOfCouriersByDate,
        formatDate: formatDate,
        keymonitor: keymonitor,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareByTime(a, b) {
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeDeclineVacation', () => {
            _self.openDeclineVacation = false;
        });
        this.$topnavbar.$on('successDeclineVacation', () => {
            _self.openDeclineVacation = false;
            swal('Uspešno', 'Uspešno odbijen godišnji', 'success')
            _self.getVacations();
        });

    },
    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.initDaysMap()
        this.getVacations()
        this.getDrivers()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function initDaysMap(){
    this.daysMap.set("Ponedeljak", 0)
    this.daysMap.set("Utorak", 0)
    this.daysMap.set("Sreda", 0)
    this.daysMap.set("Četvrtak", 0)
    this.daysMap.set("Petak", 0)
    this.daysMap.set("Subota", 0)
    this.daysMap.set("Nedelja", 0)
}

function openDeclineVacationModal(vacation){
    this.vacationToEdit = vacation;
    this.openDeclineVacation = true;
}

function getVacations() {
    let _self = this;
    // var from = new Date();
    // from.setUTCHours(0,0,0,0);
    //
    // var to = new Date();
    // to.setUTCHours(23,59,59,999);
    // console.log(from);
    // console.log(to);
    AdminApiService.getRequestedVacations()
        .then((response) => {
            _self.vacations = response.data.filter(e => !(e.status === 'REQUESTED' && e.notes != null && e.notes.length !== 0));
            _self.vacationsNotes = response.data.filter(e => (e.status === 'REQUESTED' && e.notes != null && e.notes.length !== 0));
            _self.$topnavbar.$emit('onGetVacation', _self.vacations.length);
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getDrivers();
    }
}

function checkNull(data) {
    if(data == null) return '';
    return data;
}

function formatDate(date) {
    return this.$moment(new Date(date )).format('DD-MM-YYYY')
}


function getDisplayStatus(status){
    switch (status){
        case "REQUESTED": return "Zahtevano";
        case "APPROVED": return "Odobreno";
        case "REJECTED": return "Odbijeno";
        default: return "";
    }
}

function declineVacations(vacation){
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da želite da odbijete godišnji vozaču: "+ vacation.courier.firstName + " za: "+ _self.formatDate(vacation.date) + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.updateVacation(vacation.id, "REJECTED","")
            .then((response) => {
                _self.getVacations();
                _self.getVacationsForDate();
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function approveVacations(vacation){
    let _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da želite da odobrite godišnji vozaču: "+ vacation.courier.firstName + " za: "+ _self.formatDate(vacation.date) + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.updateVacation(vacation.id, "APPROVED","")
            .then((response) => {
                _self.getVacations();
                _self.getVacationsForDate();
            })
            .catch((error) => {
                swal('Greška', error.data.localized_error_message, 'error')
            })
    });
}

function getVacationsForDate() {
    let _self = this;
    var today = this.$moment(new Date()).format('YYYY-MM-DD')
    var calendarTimestamp = Date.parse(today)

    var from = new Date(calendarTimestamp);
    from.setUTCHours(0,0,0,0);
    var to =  new Date(calendarTimestamp);
    to.setUTCHours(23,59,59,999);
    let days30 = 1000*60*60*24*30;

    this.dates = _self.generateDates(from.getTime() - 7200000, to.getTime() - 7200000 + days30)
    AdminApiService.getAllVacations(from.getTime() - 7200000, to.getTime() - 7200000 + days30)
        .then((response) => {
            var filteredData = response.data.filter(e => e.status === 'APPROVED')
            _self.driversOnVacation = new Map()
            _self.dates.forEach(e => {
                var couriers = filteredData.filter(f =>  _self.formatDate(f.date) === e )
                _self.driversOnVacation.set(e, couriers.length)
            })
            // console.log(_self.driversOnVacation)
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getNumberForDate(date){
    var parts = date.split('-');
    var newDate = new Date(parts[2], parts[1] - 1, parts[0])
    var day = this.getDisplayNameFromDay(newDate.getDay())
    console.log(day)
    return this.daysMap.get(day)
}

function getDisplayNameFromDay(day){
    switch (day) {
        case 1: return "Ponedeljak";
        case 2: return "Utorak";
        case 3: return "Sreda";
        case 4: return "Četvrtak";
        case 5: return "Petak";
        case 6: return "Subota";
        case 0: return "Nedelja";
        default: return "Nedelja";
    }
}

function getDrivers() {
    var _self = this;
    this.initDaysMap();
    AdminApiService.getDrivers('')
        .then((response) => {
            response.data.forEach(e => {
                if(e.freeDays != null && e !== ''){
                    var temp = e.freeDays.split(";")
                    temp.forEach(d => {
                        if(d !== '') _self.daysMap.set(d , _self.daysMap.get(d) + 1)
                    })
                }
            })
            _self.getVacationsForDate();
        })
        .catch((error) => {
            console.log(error);
        })
}

function getNumberOfCouriersByDate(date) {
    return this.driversOnVacation.get(date)
}

function generateDates(from, to){
    let _self = this;
    let HOUR_24 = 1000*60*60*24;
    var dates = [];
    var firstDate = from;
    while (firstDate <= to){
        dates.push(_self.formatDate(firstDate));
        firstDate = firstDate + HOUR_24;
    }
    return dates;
}





// WEBPACK FOOTER //
// ./src/components/Schedule/DriversVacations.js